/* eslint-disable no-lonely-if */

/* globals translation */

export const moneyFormat = new Intl.NumberFormat('nb-NO');

export function triggerEvent(element, type) {
  const eventDOM = document.createEvent('HTMLEvents');
  eventDOM.initEvent(type, true, false);
  element.dispatchEvent(eventDOM);
}

export function loadMore(nextPageSelector = null, listSelector = null, newItemsSelector = null, offset = 500, lazyLoad = true) {
  // Validate required parameters
  if (nextPageSelector === null || listSelector === null || newItemsSelector === null) {
    throw new Error('function is missing required parameters');
  }

  let nextPage = document.querySelector(nextPageSelector);
  const productList = document.querySelector(listSelector);

  // Used for search results
  let clearAdded = false;

  // Listen to update events to the list element
  if (productList) {
    productList.addEventListener('updated', () => {
      nextPage = document.querySelector(nextPageSelector);
    });
  }

  if (nextPage) {
    // Get the next page url
    let nextPageUrl = nextPage.getAttribute('href');

    // Define loading, used to prevent double loading
    let loading = false;

    // Listen to update events to the list element
    if (productList) {
      productList.addEventListener('updated', () => {
        if (nextPage) {
          nextPageUrl = nextPage.getAttribute('href');
        } else {
          nextPageUrl = null;
        }
      });
    }

    // Generate the loading info output
    const loadingHtml = document.createElement('div');
    const loadingText = document.createElement('span');
    const loadingIcon = document.createElement('div');
    const loadingIconInner = document.createElement('div');
    loadingHtml.id = 'maksimer-loading';
    loadingHtml.className = 'maksimer-loader';
    loadingIcon.className = 'loading-icon';
    loadingText.className = 'text';
    loadingText.innerText = (typeof translation !== 'undefined' && translation.fetching_more) ? translation.fetching_more : 'Fetching more items…';
    loadingIconInner.className = 'loading-icon-inner';
    loadingIcon.appendChild(loadingIconInner);
    loadingHtml.appendChild(loadingIcon);
    loadingHtml.appendChild(loadingText);

    const fetchData = () => {
      // Define loading, to prevent double load
      loading = true;

      // Add loading spinner info thingy
      productList.appendChild(loadingHtml);

      // Fetch next page products
      jQuery.get(nextPageUrl, (response) => {
        // Create new hidden DOM
        const htmlObject = document.createElement('html');
        htmlObject.innerHTML = response;

        // Fetch new data from the hidden DOM
        const newProducts = Array.from(htmlObject.querySelectorAll(newItemsSelector));
        const loadingSpinner = document.getElementById('maksimer-loading');
        nextPage = htmlObject.querySelector(nextPageSelector);

        // Add the new products to the existing list
        newProducts.forEach((element) => {
          // This will remove the all other .clear than the first one
          // Done to make the search page work as intended
          if (element.classList.contains('clear')) {
            if (clearAdded === true) {
              return;
            }
            clearAdded = true;
          }

          productList.appendChild(element);
        });

        // Define the next page url
        if (nextPage) {
          nextPageUrl = nextPage.getAttribute('href');
        } else {
          nextPageUrl = null;
        }

        // Remove loading info
        if (loadingSpinner) {
          loadingSpinner.parentNode.removeChild(loadingSpinner);
        }

        // Deactivate loading; get ready for round two. - FIGHT!
        loading = false;

        triggerEvent(document.body, 'load-more-triggered');
      });
    };

    if (lazyLoad === true) {
      window.addEventListener('scroll', () => {
        if ((window.pageYOffset + (window.innerHeight + offset)) > (productList.offsetTop + productList.offsetHeight) && loading === false && nextPageUrl !== null) {
          fetchData();
        }
      });
    }
  }
}

// Simulate a click event on similar elements
export function simulateSimilarClick(selector, element = 'button') {
  const allItems = Array.from(document.querySelectorAll(selector));
  allItems.forEach((item) => {
    item.addEventListener('click', () => {
      const { className } = item;
      const classQuery = className.split(' ').join('.');
      const similarItems = document.querySelectorAll(`${element}.${classQuery}`);
      similarItems.forEach((similarItem) => {
        if (item !== similarItem) {
          similarItem.click();
        }
      });
    });
  });
}

/**
 * Find similar input items and trigger the same change on them
 * Example: When changing the checked status on a checkbox,
 * find checkboxes with the same name and change the checked value on them
 *
 * @param selectors
 * @param type
 * @param byID
 */
export function simulateSimilarInputChanges(selectors, type = 'value', byID = false) {
  const fields = Array.from(document.querySelectorAll(selectors));
  fields.forEach((field) => {
    field.addEventListener('change', () => {
      let fieldValue = field.value;

      if (type === 'checkbox' || type === 'radio') {
        fieldValue = field.checked;
      }

      let selector = `[name=${field.name}]`;
      if (byID) {
        selector = `[id=${field.id}]`;
      }

      const SimilarFields = document.querySelectorAll(selector);
      SimilarFields.forEach((simField) => {
        const similarField = simField;
        if (type === 'radio') {
          if (similarField.value === field.value && !similarField.checked) {
            similarField.checked = fieldValue;
            similarField.click();
          }
        } else if (type === 'checkbox') {
          if (similarField !== field && similarField.checked !== fieldValue) {
            // similarField.checked = fieldValue;
            similarField.click();
          }
        } else {
          if (similarField !== field) {
            similarField.value = fieldValue;
            triggerEvent(similarField, 'change');
          }
        }
      });
    });
  });
}

/**
 * Calculate beauty points on the product page
 */
export function calculateBeautyPoints() {
  // Fetch the price wrapper
  const priceWrapper = document.querySelector('.product .entry-summary .price');

  // Get the element for beauty points output
  const beautyPointsOutput = document.getElementById('product-beauty-points');

  // Conversion rates - Example: 5 points per 100
  const points = Number(translation.p_ratio_points);
  const per = Number(translation.p_ratio_monetary_value);

  const observer = new MutationObserver((mutations) => {
    if (mutations[0]) {
      // Create a new element, allowing us to query for the data we need
      const htmlObject = document.createElement('div');

      // Add the mutation content into the new element
      htmlObject.innerHTML = mutations[0].target.innerHTML;

      // First try to find the sales price
      let priceContainer = htmlObject.querySelector('ins .woocommerce-Price-amount');

      // If it can't find a sales price, try to find the regular price
      if (!priceContainer) {
        priceContainer = htmlObject.querySelector('.woocommerce-Price-amount');
      }

      if (priceContainer) {
        // Remove other 💩 inside of the price wrapper
        priceContainer.querySelector('.woocommerce-Price-currencySymbol').remove();

        // Remove all spaces and convert to float
        const price = parseFloat(priceContainer.innerText.replace(/\s/g, ''));

        // Calculate the new amount of points
        // eslint-disable-next-line no-mixed-operators
        const beautyPoints = Math.round(price / per * points);

        // Replace the current points with the new one
        beautyPointsOutput.innerText = beautyPoints.toString();
      }
    }
  });

  const observerConfig = {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
  };

  observer.observe(priceWrapper, observerConfig);
}

/**
 * Creates a more sexy scroll to element
 */
export function scrollTo(to, duration) {
  const start = window.scrollY;
  const difference = to - start;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    window.scrollTo(0, Math.easeInOutQuad(currentTime, start, difference, duration));

    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };

  animateScroll();
}

/**
 * 🤯 Don't think about - just don't
 * used in the scroll animation
 */
Math.easeInOutQuad = (t, b, c, d) => {
  t /= d / 2; // eslint-disable-line
  if (t < 1) return c / 2 * t * t + b; // eslint-disable-line
  t--; // eslint-disable-line
  return -c / 2 * (t * (t - 2) - 1) + b; // eslint-disable-line
};

/**
 * Check if any of the optional products is selected
 * If so: Add a text to the title in the sticky menu
 */
export function checkIfOptionalProducts() {
  // Fetch the sticky title node
  const stickyTitle = document.querySelector('.sticky.sticky-buy-product .sticky-product-inner .product-title');

  // Fetch all the optional product checkboxes
  const optionalProduct = document.querySelectorAll('.product .entry-summary .optional-products-wrapper input.optional-products-checkbox');

  // Default to false
  let haveOptionalProducts = false;

  // Check if any of the optional product checkboxes is selected
  optionalProduct.forEach((checkbox) => {
    if (checkbox.checked) {
      haveOptionalProducts = true;
    }
  });

  if (haveOptionalProducts) {
    // If it have any optional products, the text should be added

    // Creating the new element
    const withOptionalsOutput = document.createElement('span');

    withOptionalsOutput.className = 'with-optionals';
    withOptionalsOutput.innerHTML = ` ${translation.plus_accessories}`;

    // If the element don't already exists, insert it
    if (!stickyTitle.querySelector('.with-optionals')) {
      stickyTitle.appendChild(withOptionalsOutput);
    }
  } else {
    // If it don't have any optional products selected, remove the info from the title
    if (stickyTitle) {
      const withOptionals = stickyTitle.querySelector('.with-optionals');
      if (withOptionals) {
        withOptionals.remove();
      }
    }
  }
}

/**
 * Find the current price node
 * Either the sales price or the default price
 */
export function findPriceNode(query) {
  let priceNode = document.querySelector(`${query} ins .woocommerce-Price-amount`);

  // If it can't find a sales price, try to find the regular price
  if (!priceNode) {
    priceNode = document.querySelector(`${query} .woocommerce-Price-amount`);
  }

  return priceNode;
}

/**
 * Get the current price (either sales or default) as a number
 *
 * @return number
 */
export function findPrice(container) {
  // First try to find the sales price
  let priceContainer = container.querySelector('ins .woocommerce-Price-amount');

  // If it can't find a sales price, try to find the regular price
  if (!priceContainer) {
    priceContainer = container.querySelector('.woocommerce-Price-amount');
  }

  // Create a new element, allowing us to query for the data we need
  const htmlObject = document.createElement('span');

  if (priceContainer) {
    // Add the mutation content into the new element
    htmlObject.innerHTML = priceContainer.innerHTML;

    // Remove other 💩 inside of the price wrapper
    htmlObject.querySelector('.woocommerce-Price-currencySymbol').remove();

    // Remove all spaces and convert to float
    let newPrice = htmlObject.innerText.replace('.', '');
    newPrice = newPrice.replace(',', '.');
    newPrice = newPrice.replace(/\s/g, '');

    return parseFloat(newPrice);
  }

  return 0;
}

/**
 * Update the price (either sales or default) inside of the requested container
 */
export function updatePrice(container, newPrice) {
  // Format the price with the correct money format
  const price = moneyFormat.format(Math.round(newPrice));

  // First try to find the sales price
  let priceContainer = container.querySelector('ins .woocommerce-Price-amount');

  // If it can't find a sales price, try to find the regular price
  if (!priceContainer) {
    priceContainer = container.querySelector('.woocommerce-Price-amount');
  }

  // Create a new element, allowing us to query for the data we need
  const htmlObject = document.createElement('span');
  htmlObject.className = 'woocommerce-Price-amount amount';

  // Create a new element, allowing us to query for the data we need
  const currencyOutput = document.createElement('span');
  currencyOutput.className = 'woocommerce-Price-currencySymbol';

  // Set the currency symbol inside the new output
  currencyOutput.innerText = translation.currency_symbol;

  // The space is there to simulate WooCommerce default output
  htmlObject.innerText = ` ${price}`;

  // Insert the new sum as the first node inside of the created price wrapper
  htmlObject.insertBefore(currencyOutput, htmlObject.firstChild);

  if (priceContainer) {
    // Prepend the price wrapper to the price container
    priceContainer.parentNode.prepend(htmlObject);

    // Remove the old node, to trigger the mutation API to notice a change
    priceContainer.remove();
  }

  // Add info about optional products to the sticky product name
  checkIfOptionalProducts();
}

/**
 * Find the total sum of all selected optional products
 */
export function calculateTotalOptionalProductPrices() {
  let total = 0;

  Array.from(document.querySelectorAll('.entry-summary .optional-products-wrapper input.optional-products-checkbox')).forEach((checkbox) => {
    if (checkbox.checked) {
      let { price } = checkbox.dataset;
      price = parseFloat(price);

      total += price;
    }
  });

  return total;
}

/**
 * When a user clicks outside of the current element, close it
 * This is made for the icons in the header: mini-search, mini-wishlist and mini-cart
 */
export function hideOnClickOutside(element, className) {
  // Check if element is visible on the page
  const isVisible = (elem) => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

  const outsideClickListener = (event) => {
    if (!element.contains(event.target) && isVisible(element) && document.body.classList.contains(className)) {
      // It will get here if the user click outside of 'element' when the wishlist is open

      // Remove the body class, this will close the popup
      document.body.classList.remove(className);

      // Remove the listener for the click event, don't need it when the element is closed
      document.removeEventListener('click', outsideClickListener);
    }
  };

  document.addEventListener('click', outsideClickListener);
}

/**
 * Check if a node is being hovered by the cursor
 */
export function isHover(e) {
  return (e.parentElement.querySelector(':hover') === e);
}

/**
 * Find a parent node based on the parent node's class name
 * Alternative to using jquery's closest() function;
 */
export function closestByClassName(element, className) {
  let node = element;
  if (!className) {
    return null;
  }

  if (!node) {
    return null;
  }

  // Run upwards the DOM until the current node's class contains the requested class name
  while (!node.classList.contains(className)) {
    node = node.parentNode;

    // Return null if it reaches the top without finding it
    if (!node) {
      return null;
    }
  }

  // Return the node that contains the classname requested
  return node;
}

/**
 * Simple accordion
 */
export function accordion() {
  Array.from(document.getElementsByClassName('accordion')).forEach((accordionList) => {
    const termLinks = Array.from(accordionList.getElementsByClassName('toggle-accordion'));

    termLinks.forEach((link) => {
      const parentElement = link.parentNode;
      link.addEventListener('click', (event) => {
        event.preventDefault();

        termLinks.forEach((similarTermLinks) => {
          if (similarTermLinks !== link) {
            similarTermLinks.parentNode.classList.remove('open');
          }
        });

        parentElement.classList.toggle('open');
      });
    });
  });
}

/**
 * Check if a user is beta tester or not
 */
export function isBetaTester() {
  return document.body.classList.contains('is-beta-tester');
}

/**
 * Fetch a cookie by name
 */
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }

  return null;
}

/**
 * Set a new cookie
 */
export function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`;
}

export function loader() {
  // Generate the loading info output
  const loadingWrapper = document.createElement('div');
  const loadingHtml = document.createElement('div');
  const loadingText = document.createElement('span');
  const loadingIcon = document.createElement('div');
  const loadingIconInner = document.createElement('div');
  loadingHtml.className = 'maksimer-loader';
  loadingIcon.className = 'loading-icon';
  loadingText.className = 'text';
  loadingText.innerText = (typeof translation !== 'undefined' && translation.fetching) ? translation.fetching : 'Fetching more items…';
  loadingIconInner.className = 'loading-icon-inner';
  loadingIcon.appendChild(loadingIconInner);
  loadingHtml.appendChild(loadingIcon);
  loadingHtml.appendChild(loadingText);
  loadingWrapper.appendChild(loadingHtml);

  return loadingWrapper;
}

export function closePopup(element) {
  if (element) {
    const popup = closestByClassName(element, 'popup');

    popup.classList.remove('open');
  }
}

/* eslint-disable camelcase */
export function elementPrototypes() {
  /**
   *
   * @return {Element}
   * @param {*|number} addClass
   */
  Element.prototype.slideDown = function (addClass = '') {
    const current_el_height = this.offsetHeight;

    this.style.height = 'auto';
    const item_height = this.offsetHeight;
    this.style.height = `${current_el_height}px`;
    setTimeout(() => {
      if (addClass) {
        this.classList.add(addClass);
      }

      this.style.height = `${item_height}px`;
    }, 10);

    // this.emmit( 'slide.down' );

    return this;
  };

  /**
   * @param {string|number} removeClass
   * @param {number|Function} minHeight
   * @return {Element}
   */
  Element.prototype.slideUp = function (removeClass = '', minHeight = 0) {
    this.style.height = `${minHeight}px`;
    if (removeClass) {
      this.classList.remove(removeClass);
    }

    // this.emmit( 'slide.up' );

    return this;
  };

  /**
   * @param {string|number} toggleClass
   * @param {*} minHeight
   * @return {Element}
   */
  Element.prototype.slideToggle = function (toggleClass = '', minHeight = 0) {
    const current_height = this.offsetHeight;

    if (current_height === 0 || current_height === minHeight || current_height === (+this.dataset.min_height || 0)) {
      this.slideDown(toggleClass);
    } else {
      this.slideUp(toggleClass, this.dataset.min_height || minHeight);
    }

    // this.emmit( 'slide.toggle' );

    return this;
  };
}

export function initClickers() {
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open]')) {
      const button = e.target.closest('[data-open]');
      const target_el = document.querySelector(button.dataset.open);

      button.classList.add('active');

      if (target_el) {
        target_el.slideDown();
      }
    } else if (e.target.closest('[data-togle]')) {
      const button = e.target.closest('[data-togle]');
      const target_el = document.querySelector(button.dataset.togle);

      button.classList.toggle('active');

      if (target_el) {
        target_el.slideToggle();
      }
    } else if (e.target.closest('[data-close]')) {
      const button = e.target.closest('[data-close]');
      const target_el = document.querySelector(button.dataset.close);

      button.classList.remove('active');

      if (target_el) {
        target_el.slideUp();
      }
    }
  });
}
